import React, {memo} from 'react'
import {keys} from 'lodash'
import {Button, Form, Header, List, Message, Modal} from 'semantic-ui-react'
import {
  withBackupData,
  withBackupsData,
  withErrorHandling,
  withHelmet,
  withPropsPresent,
  withServicesData,
  withNavigation
} from '../../hoc'
import {goBack} from '../../util'
import {restoreBackup} from '../../backend'
import {useSafeState} from '../../hook'

const isServicePresent = (services, name) => {
  return services.some((s) => s.name.toLowerCase() === name.toLowerCase())
}

const _RestoreBackup = (props) => {
  const {
    services = [],
    backup,
    mutateBackups,
    mutateServices,
    restoreBackup,
    history,
    navigate,
    basePath = '/c/account/backups'
  } = props

  const [state, setState] = useSafeState({
    name: `${backup.name}-restore-attempt-${backup.restoreCount}`
  })

  const validate = ({name, errors = {}}) => {
    if (!name) {
      errors['backup.service.name.required'] = 'Name required'
    } else {
      delete errors['backup.service.name.required']
      if (isServicePresent(services, name)) {
        errors['backup.service.present'] = 'Service already present. Change name and try again'
      } else {
        delete errors['backup.service.present']
      }
    }
    return errors
  }

  const onInputChange = (e) => {
    let updatedState = {...state, ...{[e.target.name]: e.target.value}}
    let errors = {}
    if (state.submitted) {
      errors = validate(updatedState)
      updatedState = {...updatedState, ...{errors}}
    }
    setState(updatedState)
  }

  const onClose = () => {
    goBack(history, navigate, basePath)
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    const errors = validate(state)
    if (keys(errors).length) {
      setState({...state, ...{errors}})
      return
    }
    setState({...state, submitting: true})
    await restoreBackup(backup.id, state.name)
    mutateServices()
    mutateBackups()
    navigate(`${basePath}?restoreSucceeded=${state.name}`)
  }

  const {name, errors, submitting} = state
  const hasServicePresentError = keys(errors).some((k) => k.indexOf('backup.service.present') > -1)
  const hasNameError = keys(errors).some((k) => k.indexOf('backup.service.name') > -1)
  const hasErrors = hasServicePresentError || hasNameError

  return (
    <Modal open={true} closeOnDimmerClick={true} closeIcon={true} onClose={onClose}
           style={{position: '!important relative'}} data-testid='backup-restore-modal'>
      <Header content='Restore Service Backup'/>
      <Modal.Content>
        <Form error={hasErrors}>
          <Form.Field error={hasNameError || hasServicePresentError} required>
            <label>Name</label>
            <Form.Input placeholder='Enter service name'
                        name='name'
                        value={name}
                        data-testid='backup-name-textbox'
                        onChange={onInputChange}/>
          </Form.Field>
          <Message error data-testid='backup-restore-errors'>
            <Message.Content>
              <List bulleted>
                {
                  keys(errors).map((key) => (
                    <List.Item key={key}>{errors[key]}</List.Item>
                  ))
                }
              </List>
            </Message.Content>
          </Message>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose} data-testid='backup-restore-cancel-button'>Cancel</Button>
        <Button primary onClick={onSubmit}
                data-testid='backup-restore-submit-button'
                loading={submitting}>Restore</Button>
      </Modal.Actions>
    </Modal>
  )
}

let RestoreBackup = (props) => {
  const {handleError} = props
  props = {
    ...props,
    history: window.history,
    restoreBackup: handleError(restoreBackup)
  }
  return (<_RestoreBackup {...props}/>)
}

RestoreBackup = withHelmet(RestoreBackup, 'Restore Backup')
RestoreBackup = withPropsPresent(RestoreBackup, ['backup'])
RestoreBackup = withBackupData(RestoreBackup, 'Loading backup...')
RestoreBackup = withBackupsData(RestoreBackup, 'Loading backups...')
RestoreBackup = withServicesData(RestoreBackup, 'Loading services...')
RestoreBackup = withNavigation(RestoreBackup)
RestoreBackup = withErrorHandling(RestoreBackup)
RestoreBackup = memo(RestoreBackup)

export {_RestoreBackup, RestoreBackup, isServicePresent}

export default RestoreBackup